import { render, staticRenderFns } from "./article-history-detail.vue?vue&type=template&id=5f00e21e&scoped=true&"
import script from "./article-history-detail.vue?vue&type=script&lang=js&"
export * from "./article-history-detail.vue?vue&type=script&lang=js&"
import style0 from "./article-history-detail.vue?vue&type=style&index=0&id=5f00e21e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00e21e",
  null
  
)

component.options.__file = "article-history-detail.vue"
export default component.exports